import React, { FC } from 'react'
import styled from 'styled-components'

interface Props {
  path: string
  size: string
}

const CircleImage: FC<Props> = ({ path, size }) => {
  return <Image src={path} size={size} />
}

export default CircleImage

const Image = styled.img<{ size: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  border-radius: 50%;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.16);
`
